import React from 'react';
import PropTypes from 'prop-types';
import Popover from 'kepler/lib/components/Popover';
import { get } from 'lodash';

import {
  recordIntent,
  productToRPSMapping
} from '../../../lib/appcenterIntent';
import getContent from '../../../lib/dictionaryFetcher';
import { products } from '../lib/productBundlesStaticMapping';

class ProductBundleProducts extends React.Component {
  constructor(props) {
    super(props);
  }

  // track FPTI & record intent
  _trackClick = (product, productObj) => {
    const { app, fptiHelper } = this.props;
    fptiHelper.fptiClick({ link: product });

    if (productObj.intent) {
      recordIntent({
        csrf: app.csrf,
        productArr: [productToRPSMapping[productObj.intent]]
      });
    }
  };

  _getLinks = (product, productObj) => {
    if (productObj.mobileApps) {
      return (
        <span>
          {' '}
          <a
            onClick={() => this._trackClick(product, productObj)}
            href={productObj.iosLink_url}
            className="ppvx_text--md ppvx_text--medium link"
          >
            {getContent('covidbundles', 'forIOS', '')}
          </a>{' '}
          &nbsp; | &nbsp;
          <a
            onClick={() => this._trackClick(product, productObj)}
            href={productObj.androidLink_url}
            className="ppvx_text--md ppvx_text--medium link"
          >
            {getContent('covidbundles', 'forAndroid', '')}
          </a>
        </span>
      );
    }
    return (
      <span>
        <a
          onClick={() => this._trackClick(product, productObj)}
          href={productObj.link_url}
          className="ppvx_text--md ppvx_text--medium link"
        >
          {' '}
          {getContent('covidbundles', `${product}.link`, '')}
        </a>
      </span>
    );
  };

  _getRecommendationTiles = suggestedProducts => {
    let isMobile =
      get(this.props, 'app.deviceInfo.isMobile', false) ||
      get(this.props, 'app.deviceInfo.isTablet', false);
    return suggestedProducts && suggestedProducts.length ? (
      <span>
        <hr />
        <div className="ppvx_row tiles">
          {suggestedProducts.map(product => {
            const productObj = products[product];
            const popoverContent = (
              <div className={product + 'tooltip'}>
                <span>
                  {getContent('covidbundles', `${product}.description`, '')}
                </span>
              </div>
            );
            let image;
            if (productObj.imageType && productObj.imageType === 'CDN') {
              image = (
                <div
                  className="cdnIcon"
                  style={{
                    background: `url(${productObj.image}) center center/35px no-repeat #FFFFFF`
                  }}
                />
              );
            } else {
              image = (
                <span
                  className={`ppvx_icon ppvx_icon--size_lg ppvx_icon-${productObj.image} icon`}
                />
              );
            }
            return (
              <div className="ppvx_col-md-12 ppvx_col-lg-3 tile" key={product}>
                <div className="tooltip">
                  <Popover
                    placement="top"
                    content={popoverContent}
                    trigger={isMobile ? 'click' : 'hover'}
                  >
                    <span
                      className={`ppvx_icon ppvx_icon--size_sm ppvx_icon-info`}
                    />
                  </Popover>
                </div>
                <div className="image">{image}</div>
                <div>
                  <p className="ppvx_text--md ppvx_text--medium recommendation-title">
                    {getContent('covidbundles', `${product}.title`, '')}
                  </p>
                  {this._getLinks(product, productObj)}
                </div>
              </div>
            );
          })}
        </div>
      </span>
    ) : null;
  };

  _getBundletile = (name, bundle) => {
    const heroProduct = products[bundle.heroProduct];
    let image;
    if (heroProduct.imageType && heroProduct.imageType === 'CDN') {
      image = (
        <div
          className="hero-cdn-icon"
          style={{
            background: `url(${heroProduct.image}) center center/60px 60px no-repeat #FFFFFF`
          }}
        />
      );
    } else {
      image = (
        <span
          className={`ppvx_icon ppvx_icon--size_lg ppvx_icon-${heroProduct.image} hero-icon`}
        />
      );
    }
    const tempWaiverDate = get(products, 'qrCode.tempWaiverDate', '');

    return (
      <div id={name} className="bundleTile" key={name}>
        <a name={name}></a>
        <div className="header">
          <p className="ppvx_text--xl2 ppvx_text--medium headerTitle">
            {getContent('covidbundles', `${name}.sectionTitle`, '')}
          </p>
          <p className="ppvx_text--lg subText">
            {getContent('covidbundles', `${name}.subtitle`, '')}
          </p>
        </div>

        <div className="heroProduct">
          <div className="ppvx_row">
            <div className="ppvx_col-md-12 ppvx_col-lg-1 title-row">
              {image}
              <p className="ppvx_text--xl2 ppvx_text--medium title-mini">
                {getContent('covidbundles', `${bundle.heroProduct}.title`, '')}
              </p>
            </div>
            <div className="ppvx_col-md-12 ppvx_col-lg-11">
              <p className="ppvx_text--lg ppvx_text--medium title">
                {getContent('covidbundles', `${bundle.heroProduct}.title`, '')}
              </p>
              <p
                className="ppvx_text--lg subText"
                dangerouslySetInnerHTML={{
                  __html: getContent(
                    'covidbundles',
                    `${bundle.heroProduct}.description`,
                    '',
                    { params: { tempWaiverDate } }
                  )
                }}
              ></p>
              {this._getLinks(bundle.heroProduct, heroProduct)}
            </div>
          </div>
        </div>

        <div className="recommendations">
          {this._getRecommendationTiles(bundle.suggestedProducts)}
        </div>
      </div>
    );
  };
  render() {
    const { bundles } = this.props;
    return (
      <div>
        {Object.keys(bundles).map(bundleName => {
          return this._getBundletile(bundleName, bundles[bundleName]);
        })}
      </div>
    );
  }
}

ProductBundleProducts.propTypes = {
  app: PropTypes.object,
  fptiHelper: PropTypes.object,
  bundles: PropTypes.object
};

export default ProductBundleProducts;
